export var fieldConfig = [
    { key: 'receiver_phone', label: '收货人电话', type: 'phone', required: true },
    { key: 'receiver_address', label: '收货地址', type: 'text', required: true },
    { key: 'deliver_user', label: '送货人', type: 'account', required: true },
    { key: 'deliverer_phone', label: '送货人手机号', type: 'phone_30', required: false },
    { key: 'delivery_plate_number', label: '送货车牌号', type: 'text_30', required: false },
    { key: 'deliver_time', label: '送货时间', type: 'date', required: true },
    { key: 'logistics_code', label: '物流单号', type: 'number' },
    { key: 'remark', label: '单据备注', type: 'limitText' }
];
export var validationRules = {};
export var errorMessages = {
    NETWORK_ERROR: '网络请求失败,请重试',
    TIMEOUT_ERROR: '请求超时,请重试',
    STATUS_CHANGED: '以下单据状态已变更,无法修改: ',
    VALIDATION_ERROR: '请检查输入是否正确',
    UPDATE_SUCCESS: '修改成功',
    UPDATE_PARTIAL_SUCCESS: '部分修改成功',
    UPDATE_FAILED: '修改失败'
};
